module.exports = __webpack_public_path__ + "media/svg/company-appeal-selected-c43e0517.svg";